import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styles from './LanguageSwitcher.css';

const LanguageSwitcher = ({ intl, loggedOut }) => {
  const linkTarget =
    loggedOut === true
      ? '/app/settings?op=language_landingpage'
      : '/settings/account/language';
  return (
    <a href={linkTarget} className={styles.link}>
      {intl.formatMessage({ id: 'FOOTER_LANGUAGES' })}
      :&nbsp;
      <span className={styles.language}>
        {intl.formatMessage({ id: 'ACTIVE_LANGUAGE' })}
      </span>
    </a>
  );
};

LanguageSwitcher.propTypes = {
  intl: intlShape,
  loggedOut: PropTypes.bool,
};

export default injectIntl(LanguageSwitcher);
